


import { Row, Col, Button, Form, Input, Card} from 'antd';
import React, { useEffect,useState } from 'react';
import * as Icon from "react-feather";
import { useDispatch, useSelector } from 'react-redux';
import userService from '../../services/user-service';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import constantService from '../../services/constant-service';
import authenAction from "../../redux/action/authen-action";

const Profile = () => {

    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const userInfo = useSelector(state => state.authenReducer.userInfo);
    const [isEditing, setIsEditing] = useState(false);
    const [roleList, setRoleList] = useState([]);
    const { profile, userRole } = userInfo;
	const { firstName, lastName, telNo, email } = profile;

    useEffect(() => {
        async function initData() {
            const { userRole } = await constantService.getUserRole();
			setRoleList(userRole);
		}
		initData();
        // console.log('userInfo ', userInfo);
	}, []);

    const onSave = async () => {
		try {
			const values = await form.validateFields();
			try {

                dispatch(appLoaderAction.enable());
                
                let bean = JSON.parse(JSON.stringify(userInfo));
                bean.profile.email = values.email;
                bean.profile.firstName = values.firstName;
                bean.profile.lastName = values.lastName;
                bean.profile.telNo = values.telNo;

                await userService.edit(bean);
                
                // console.log(' save userInfo ', userInfo);
                dispatch(authenAction.updateProfile(bean));
                dispatch(appLoaderAction.disale());

                notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');

                setIsEditing(false);
			} catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
			}
		} catch (errorInfo) {
			notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
		}
	};

    const getUserRole = (value) =>{
        let userRole = roleList.find((item) => item.value === value);
        if (userRole) {
            let labelEn = userRole.labelEn;
            return <span>{labelEn}</span>; 
        }
    }

    return (
        <div className="container h-100">
            <div className="title-page">
            <h2 className="color-primary-title">ข้อมูลผู้ใช้</h2>
                <Card className="mt-4" bordered={false}>
                    <Form
                        layout="vertical"
                        name="add_edit_user"
                        preserve={false}
                        form={form}
                        validateMessages={{
                            required: 'โปรดระบุ',
                        }}>

                        <Row gutter={[30, 5]} >
                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    initialValue={firstName}
                                    label="ชื่อ"
                                    name="firstName"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}>
                                    {isEditing ? <Input /> : firstName}
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    initialValue={lastName}
                                    label="นามสกุล"
                                    name="lastName"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}>
                                    {isEditing ? <Input /> : lastName}
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    initialValue={email}
                                    label="อีเมล"
                                    name="email"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true,
                                            type: 'email',
                                        },
                                    ]}>
                                    {email}
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    initialValue={telNo}
                                    label="เบอร์โทรศัพท์"
                                    name="telNo"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                        () => ({
                                            validator(rule, value) {
                                                var numbers = /^[0-9]+$/;

                                                if (value && value.match(numbers)) {
                                                    return Promise.resolve();
                                                }

                                                return Promise.reject('โปรดระบุตัวเลขเท่านั้น');
                                            },
                                        }),
                                    ]}>
                                    {isEditing ? <Input maxLength={10} /> : telNo}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    initialValue={userRole}
                                    label="สิทธิการใช้งาน"
                                    name="userRole"
                                    className="mb-4">
                                    {getUserRole(userRole)}
                                </Form.Item>    
                            </Col>
                        </Row>
                    </Form>

                    <div className="text-center mt-4 pt-2">
                        {!isEditing ? (
                            <>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setIsEditing(true);
                                    }}>
                                    <i className="feather icon-edit-2 mr-2"></i> แก้ไข
                                </Button>{' '}
                                
                                {/* <Button type="danger" onClick={doUserLogout}>
                                    <i className="feather icon-log-out mr-2"></i> Logout
                                </Button> */}
                            </>
                        ) : (
                            <div>
                                <Button type="primary" className="mx-2" onClick={onSave}>
                                    <Icon.Save className="me-2" size={17}/>บันทึก
                                </Button>
                                <Button key="back" 
                                    className="mx-2"
                                    className="btn-gray" 
                                    onClick={() => {
                                        setIsEditing(false);
                                        form.resetFields();
                                    }}>
                                    ยกเลิก
                                </Button>
                            </div>
                        )}
                    </div>     
                </Card>
            </div>
        </div>
    )
}

export default Profile;